import React from 'react';
import { Heading } from '@klp/design/Heading';
import { Illustration, PictogramName } from '@klp/design/Illustrations';
import { Grid } from '@material-ui/core';
import type { ContractStatisticsKeys } from '../services/rtkApi';

type ContractToRegistrationStatisticsProps = {
    statistics: Record<ContractStatisticsKeys, number> | undefined;
};

export const ContractToRegistrationStatistics: React.FC<
    ContractToRegistrationStatisticsProps
> = ({ statistics }) => {
    return (
        <Grid container={true} justifyContent="flex-start">
            <Grid item={true} xs={12} sm={6} md={4} lg={4}>
                <Grid container={true} direction="row">
                    <Grid item={true}>
                        <Illustration
                            pictogram={PictogramName.STATUS.TANNHJUL}
                            klpPalette="secondary"
                            klpColor="medium"
                            size="xlarge"
                            data-cy="FrontpageCard-Illustration"
                        />
                    </Grid>
                    <Grid item={true}>
                        <Heading klpHeadingLevel="THREE" klpColor="dark">
                            {' '}
                            {statistics?.Ny ?? 0}
                        </Heading>
                        <Heading
                            klpHeadingLevel="SIX"
                            klpColor="dark"
                            translation="contractRegistration.newProcess"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item={true} xs={12} sm={6} md={4} lg={4}>
                <Grid container={true} direction="row">
                    <Grid item={true}>
                        <Illustration
                            pictogram={PictogramName.BYGNINGER.EIENDOM}
                            klpPalette="secondary"
                            klpColor="medium"
                            size="xlarge"
                            data-cy="FrontpageCard-Illustration"
                        />
                    </Grid>
                    <Grid item={true}>
                        <Heading klpHeadingLevel="THREE" klpColor="dark">
                            {' '}
                            {statistics?.PagaaendeForvalter ?? 0}
                        </Heading>
                        <Heading
                            klpHeadingLevel="SIX"
                            klpColor="dark"
                            translation="contractRegistration.ongoingProcessForvalter"
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item={true} xs={12} sm={6} md={4} lg={4}>
                <Grid container={true} direction="row">
                    <Grid item={true}>
                        <Illustration
                            pictogram={PictogramName.BANK_OG_SPARING.KALKULATOR}
                            klpPalette="secondary"
                            klpColor="medium"
                            size="xlarge"
                            data-cy="FrontpageCard-Illustration"
                        />
                    </Grid>
                    <Grid item={true}>
                        <Heading klpHeadingLevel="THREE" klpColor="dark">
                            {' '}
                            {statistics?.PagaaendeOekonomi ?? 0}
                        </Heading>
                        <Heading
                            klpHeadingLevel="SIX"
                            klpColor="dark"
                            translation="contractRegistration.ongoingProcessFinance"
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
